import { render } from "./EditVeteranDialog.vue?vue&type=template&id=206e836d"
import script from "./EditVeteranDialog.vue?vue&type=script&lang=js"
export * from "./EditVeteranDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__